export interface ApiOrg {
  name: string;
  twrn: string;
}

export class Org {
  name: string;
  twrn: string;

  constructor(data: ApiOrg) {
    this.name = data.name;
    this.twrn = data.twrn;
  }
}
